import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { Subscricao } from "src/app/model/subscricao.model";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ParticipanteConglomerado } from "src/app/model/participante.conglomerado.model";
import { Conglomerado } from "src/app/model/conglomerado.model";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { HttpParams } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class ConglomeradoService extends FgiBackEndService<Conglomerado>{

    getNewEntity(): Conglomerado {
        const model = new Conglomerado();
        model.dataRegistro = new Date();
        return model;
    }

    protected getResourceURL(): string {
        return 'front/conglomerado';
    }

    getConglomerados(params?: any): any{
        return this.http.get(`${this.BASE_URL}/`, {params: params}).pipe(
            catchError((e) => this.handleError(e))) as Observable<Array<Subscricao>>;
    }

    getNovoConglomerado(): Observable<Conglomerado> {
        return this.http.get(`${this.BASE_URL}/novo-conglomerado`).pipe(
            catchError((e) => this.handleError(e))) as Observable<Conglomerado>;
    }

    salvar(conglomerado: Conglomerado) {
        const options = blockUi();
        return this.http.post(`${this.BASE_URL}`, conglomerado, options).pipe(
          catchError((e) => this.handleError(e))) as Observable<any>;
    }

    editar(id: number, participanteConglomerado: ParticipanteConglomerado[]) {
        const options = blockUi();
        return this.http.post(`${this.BASE_URL}/${id}`, participanteConglomerado, options).pipe(
          catchError((e) => this.handleError(e))) as Observable<any>;
    }

    atualizaValoresParticipantes(participantes: ParticipanteConglomerado[]): Observable<ParticipanteConglomerado[]> {
        const options = blockUi();
        return this.http.post(`${this.BASE_URL}/atualizar-participantes`, participantes, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<ParticipanteConglomerado[]>;
    }

    obterAgentesDisponiveis(id: number): Observable<AgenteFinanceiro[]> {
        let params = new HttpParams();
        params = params.append('id', id ? id : '');
        return this.http.get(`${this.BASE_URL}/agentes-financeiros-disponiveis`, {params: params}).pipe(
            catchError((e) => this.handleError(e))) as Observable<AgenteFinanceiro[]>;
    }
    buscarAtivosPorAgente(idAgente: number) : Observable<Array<ParticipanteConglomerado>> {
      const options = blockUi();
      return this.http.get(`${this.BASE_URL}/agentes/${idAgente}/participantes`, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<Array<ParticipanteConglomerado>>;
    }


    getConglomerado(id: number): Observable<Conglomerado> {
        const options = blockUi();
        return this.http.get(`${this.BASE_URL}/${id}`, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<Conglomerado>;
    }
}
